a<template>
  <div id="app">
    <template v-if="signedIn">
      <template v-if="isAdviser">
        <HeaderItem :signedIn="true" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else-if="isStaff">
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="true" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="true" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <template v-else>
      <template v-if="isAdviser">
        <HeaderItem :signedIn="false" :isAdviser="true" :isStaff="false" :id="id" />
      </template>
      <template v-else>
        <HeaderItem :signedIn="false" :isAdviser="false" :isStaff="false" :id="id" />
      </template>
    </template>
    <main class="common-main">
      <h2 class="common-title">ベーシックプランにアップグレード</h2>

      <!-- 認証済みの時はメインの画面を表示 -->
      <div v-if="signedIn">
        <template v-if="isLoading">
          <div class="loading"></div>
        </template>
        <div v-else-if="hasUserData">
          <template v-if="isAdviser">
            アドバイザーは課金できません
          </template>
          <template v-else-if="isStaff">
            運営アカウントは課金できません
          </template>
          <template v-else>
            <div class="item">
              <p>ベーシックプランは、相談数の制限なくCancerWithをお使いいただける有料プランです。</p>
              <p>アカウント作成時は「トライアル（無料）」となっています。無制限にご利用される場合は、以下のボタンよりアップグレードをしてください。</p>
              <PaymentPlanModuleItem />

              <h2>ベーシックプランへアップグレードするために、支払いへ進んでください</h2>
              <form :action="paymentCreateCheckoutSessionApiUrl" method="POST">
                <input type="hidden" name="priceId" :value="paymentBasicPlanPriceId" />
                <input type="hidden" name="clientReferenceId" :value="id" />
                <input type="hidden" name="customerEmail" :value="mailaddress" />
                <button type="submit" class="payment-button">支払いへ進む</button>
              </form>
              <br>

              <h4>新着キャンペーン</h4>
              <div v-for="campaign in campaignInfo" :key="campaign.id">
                <ul class="announce">
                  <li><a :href="campaign.link" target="_blank">
                    {{campaign.title[0]}}
                  </a></li>
                </ul>
              </div>
              <div style="text-align: right">
                <a href="https://cancerwith.com/blog/archive/category/%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3" target="_blank">[ 一覧 ]</a>
              </div>
              

              <br><br>
              <h4>ご利用にあたって</h4>
              <ul class="announce">
                <li>支払いはStripe（外部サイト）に遷移して行います。</li>
                <li>ご利用は1ヶ月単位となります。期間中に解約手続きを行わない限り、利用期間満了時に自動更新されます。</li>
                <li>利用期間中の途中解約や返金は、対応しておりません。</li>
                <li>解約する場合は、プロフィールページから「支払いの管理」に移動しキャンセルしてください。</li>
                <li>ベーシックプランや支払い方法などに関するお問い合わせは <a :href="contactUrl">こちら</a> よりお願いします。</li>
              </ul>
            </div>
          </template>
        </div>
        <div class="text-box" v-else>
          アカウント情報を設定してください
          <a class="link-button" href="/profileSetting">アカウント設定</a>
        </div>
      </div>

      <!-- 認証していない時はログイン画面を表示 -->
      <div v-else>
        <LoginItem :createButton="false" />
      </div>
    </main>
    <FooterItem :contactUrl="contactUrl" :hiddenFooterFixedButton="true" />
  </div>
</template>

<script>
import { API, Auth, graphqlOperation, Analytics, /*Logger*/ } from "aws-amplify"
//import { AmplifyEventBus } from 'aws-amplify-vue'
import HeaderItem from './Header'
import FooterItem from './Footer'
import LoginItem from './Login'
import PaymentPlanModuleItem from './PaymentPlanModule'

//import { getUser } from "./graphql/queries"
import { listStaffAllowListsBySpecificUser } from './graphql/queries'
import { listUsersBySpecificUser } from "./graphql/queries"
import { Common } from './Common.js'
import { onAuthUIStateChange } from '@aws-amplify/ui-components';
import axios from 'axios'


//const logger = new Logger('Payment');
//window.LOG_LEVEL = 'VERBOSE'
//logger.info('info bar');
//logger.debug('debug bar');
//logger.warn('warn bar');
//logger.error('error bar');
Analytics.autoTrack('pageView', {
  enable: true,
  eventName: 'pageView',
  type: 'multiPageApp',
  provider: 'AWSPinpoint',
  getUrl: () => {
    return window.location.origin + window.location.pathname;
  }
});

export default {
  name: 'payment',
  components : {
    HeaderItem,
    FooterItem,
    LoginItem,
    PaymentPlanModuleItem,
  },
  mixins:[Common],
  data(){
    return{
      authState: undefined,
      unsubscribeAuth: undefined,
      signedIn: false,
      id: '',
      mailaddress: '',
      userId: '',
      userType: '',
      isAdviser: false,
      isStaff: false,
      hasUserData: false,
      contactUrl: '',
      isLoading: true,
      displayName: '',
      paymentCustomerId: '',
      paymentCreateCheckoutSessionApiUrl: '',
      paymentBasicPlanPriceId: '',
      campaignInfo: [],
    }
  },
  
  filters: {
  },

  mounted() {
    var parseString = require('xml2js').parseString
    axios
      .get('https://cancerwith.com/blog/rss/category/%E3%82%AD%E3%83%A3%E3%83%B3%E3%83%9A%E3%83%BC%E3%83%B3?type=json')
      .then(response => {
        parseString(response.data, (err, result) => {
          if (err) {
            //alert(err)
          } else {
            this.campaignInfo = result.rss.channel[0].item
          }
        })
      })
  },

  methods: {
  },

  beforeDestroy() {
    this.unsubscribeAuth();
  },

  async beforeCreate() {
    this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
      this.authState = authState;
      this.user = authData;
      if (authState === 'signedin') {
        let cognitoUser = await Auth.currentAuthenticatedUser()
        this.signedIn = true
        this.id = cognitoUser.username

        // TODO: ここで hasUserData の確認処理をキックし、リロードの要不要を判定
        location.reload(1)
      } else if (authState === 'signedout') {
        // ログアウト前の情報を破棄
        this.$destroy()
        location.reload(1)
      } else {
        this.signedIn = false
      }
    });
    
    // Auth.currentAuthenticatedUser()でユーザ情報を取得する。
    // 取得できなければ認証ステータスをfalseに設定する
    try {
      let cognitoUser = await Auth.currentAuthenticatedUser()
      this.signedIn = true
      this.id = cognitoUser.username
      this.mailaddress = cognitoUser.attributes.email
    } catch (err) {
      this.signedIn = false
    }

    // 認証情報でUserデータを確認
    try {
      let userData = await API.graphql(graphqlOperation(
        listUsersBySpecificUser, {mailAddress: this.mailaddress, limit: 1}
      ))
      this.userId = userData.data.listUsersBySpecificUser.items[0].id
      this.userType = userData.data.listUsersBySpecificUser.items[0].type
      this.paymentCustomerId = userData.data.listUsersBySpecificUser.items[0].paymentCustomerId
      if (userData.data.listUsersBySpecificUser.items[0].type === 'adviser') {
        this.isAdviser = true
      } else {
        this.isAdviser = false
      }
      if (userData.data.listUsersBySpecificUser.items[0].id) {
        this.hasUserData = true 
      }
      let env = this.getEnv(location.hostname)
      this.appClass = this.getAppDivClass(location.hostname)
      if (this.appClass === 'hama') {
        this.contactUrl = 'https://share.hsforms.com/1qOJQdDxdSbSqrkrMw8jeFA46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // 浜松オンラインがん相談版
      } else {
        this.contactUrl = 'https://share.hsforms.com/1Bs-IcJO-TJOoLtoLHONvYQ46sq5?cancerwith_userid=' + this.id + '&cancerwith_env=' + env // CancerWith版
      }
    } catch (err) {
      // 運営アカウントか判定
      try {
        let staffAllowData = await API.graphql(
          graphqlOperation(listStaffAllowListsBySpecificUser, {
            mailAddress: this.mailaddress,
            limit: 1
          })
        )
        if (
          staffAllowData.data.listStaffAllowListsBySpecificUser.items[0].mailAddress ===
          this.mailaddress
        ) {
          // 運営モード
          this.userId = ''
          this.userType = 'adviser'
          this.isAdviser = false
          this.isStaff = true
          this.hasUserData = true
          this.contactUrl = ''
        } else {
          this.userId = ''
          this.userType = ''
          this.isAdviser = false
          this.isStaff = false
          this.hasUserData = false
          this.contactUrl = ''
        }
      } catch (err) {
        this.userId = ''
        this.userType = ''
        this.isAdviser = false
        this.isStaff = false
        this.hasUserData = false
        this.contactUrl = ''
        this.$router.push({ path: '../dashboard' })
      }
    }
    
    // 課金モードの確認
    let paymentActiveStatus = this.getPaymentActiveStatus(location.hostname)
    if (!paymentActiveStatus) {
      // 課金モード外のアクセスの場合はリダイレクト
      this.$router.push({ path: '../dashboard' })
    }

    this.paymentCreateCheckoutSessionApiUrl = 'https://' + this.getPaymentApiDomain(location.hostname) + '/subscription/createCheckoutSession'
    this.paymentBasicPlanPriceId = this.getPaymentBasicPlanPriceId(location.hostname)
    this.isLoading = false
    
    Analytics.record({
      name: 'accessLog', 
      attributes: { 
        page: 'Payment',
        url: window.location.origin + window.location.pathname,
        userid: this.id,
        userType: this.userType
      }
    });

    // GA
    if (location.hostname === 'cancerwith.com') {
      this.$gtag.pageview({
        page_path: '/user/payment',
        page_title: 'User:支払い'
      })
    }
  }
};
</script>

<style src="./assets/style.css" />
 